export const App = 'App';
export const Consultancy = 'Consultancy';
export const Institution = 'Institution';
export const System = 'System';

const allRoles = [
  App,
  Consultancy,
  Institution,
  System,
];

export default allRoles;
